exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tax-filing-redirection-container{position:static !important}.tax-filing-redirection{position:absolute;top:0;left:0;bottom:0;right:0;padding:0 calc(var(--spacing)*2)}.tax-bottom-pd-20-important{padding-bottom:20px !important}.tax-filing-redirection-loader{border:3px solid #d6d6d6;border-top:3px solid #878787;border-radius:50%;width:30px;height:30px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}", ""]);

// exports
